<template>
  <div class="m-4 md:mx-8 md:mt-16">
    <div class="flex flex-col md:flex-row md:items-center justify-between mb-4 space-y-2 md:space-y-0">
      <span class="font-semibold text-primario text-lg tracking-wide">
        {{ $t("lang.msg.certificates") }}
      </span>
      <div class="flex space-x-2 w-full md:max-w-lg">
        <ButtonAction @action="toggleActiveCertificate" color="gray" large>
          {{ showActive ? $t('lang.msg.viewDisactives') : $t('lang.msg.viewActives') }}
        </ButtonAction>
        <ButtonRedirect route="adminNewCertificationDetail" color="gray">
          {{ $t("lang.msg.add") }}
        </ButtonRedirect>
      </div>
    </div>
    <datatable :data="data" :headers="headers" @on-row-click="openItemView" />
  </div>
</template>

<script>
import AdminMixin from "@/components/mixins/AdminMixin";
import DataTable from "@/components/shared/DataTable";
import CalendarMixin from "@/components/mixins/CalendarMixin";

export default {
  name: "Certificates",
  mixins: [AdminMixin, CalendarMixin],
  components: {
    datatable: DataTable
  },
  data() {
    return {
      data: [],
      allData: [],
      factories: [],
      booleanArray: [
        { id: true, name: "Activo" },
        { id: false, name: "Inactivo" }
      ],
      headers: {
        idCertificate: "#",
        certificateName: this.$t("lang.fields.name"),
        certificateDate: {
          name: this.$t("lang.msg.dischargeDate"),
          type: Date
        },
        certificateEndDate: {
          name: this.$t("lang.msg.dateOfExpiry"),
          type: Date
        },
        certificateActive: {
          name: this.$t("lang.msg.active"),
          type: Boolean
        }
      }
    };
  },
  created() {
    this.fetchDataCer(`api/Certificats/GetCertificat`);
  },
  methods: {
    fetchDataCer(url) {
      this.fetchUrl = url;
      this.$axios.get(url).then((response) => {
        this.data = response.data.filter(element=>{
        return element.certificateActive==this.showActive;});
        this.allData = response.data;
      });
    },
    openItemView(item) {
      this.$router.push({
        name: "adminCertificationDetail",
        params: {
          idCertificate: item.idCertificate
        }
      });
    },addOrEditItem(addURL, editUrl, callback = null) {
      let url = "";
      let message = "";

      if (this.isEditing) {
        message = "Registro actualizado con éxito";
        url = editUrl;
      } else {
        message = "Registro añadido con éxito";
        url = addURL;

        // Añadir active al añadir por algun motivo del backend. ¯\_(ツ)_/¯
        this.$set(this.newItem, "active", true);
      }

      this.$axios.post(url, this.newItem).then(() => {
        // After the first request has completed successfully...
        // it either calls a callback function or it fetches all the paginatedData
        if (callback) {
          callback();
        } else {
            this.fetchDataCer(this.fetchUrl);
            this.isEditing = false;           
        }
        this.openAlert('success', message, null);

        this.isModalOpen = false;
      });
    },
    toggleActiveCertificate(){
      this.showActive= !this.showActive
      this.data=this.allData.filter(element=>{
        return element.certificateActive==this.showActive;
      });
    }
  }
};
</script>